import { Schema } from "effect";

export const GitHubAccountType = {
  Organization: "Organization",
  User: "User",
} as const;

export type GitHubAccountTypeKey =
  keyof typeof GitHubAccountType;
export type GitHubAccountTypeValue =
  (typeof GitHubAccountType)[GitHubAccountTypeKey];

export const githubAccountTypes = Object.values(
  GitHubAccountType
);

export const GitHubAccountTypeSchema = Schema.Literals(
  githubAccountTypes
);

export const GitHubRepositorySelection = {
  All: "all",
  Selected: "selected",
} as const;

export type GitHubRepositorySelectionKey =
  keyof typeof GitHubRepositorySelection;
export type GitHubRepositorySelectionValue =
  (typeof GitHubRepositorySelection)[GitHubRepositorySelectionKey];

export const githubRepositorySelections = Object.values(
  GitHubRepositorySelection
);

export const GitHubRepositorySelectionSchema =
  Schema.Literals(githubRepositorySelections);

export const GitHubIssueStatus = {
  Open: "open",
  Closed: "closed",
  Resolved: "resolved",
} as const;

export type GitHubIssueStatusKey =
  keyof typeof GitHubIssueStatus;
export type GitHubIssueStatusValue =
  (typeof GitHubIssueStatus)[GitHubIssueStatusKey];

export const githubIssueStatuses = Object.values(
  GitHubIssueStatus
);

export const GitHubIssueStatusSchema = Schema.Literals(
  githubIssueStatuses
);

export * from "./ids";
